import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from '@wit-support/ui';
import { FieldShell } from './field-shell.js';
import { useDraftValue } from '../lib/use-draft-value.js';
/**
 * Разбор дробного числа, набранного человеком: принимает и «1,5», и «1.5».
 * Пусто → `undefined` (ошибка «обязательное» у схемы), не число → исходная
 * строка (схема `z.number()` отвергнет её с понятным сообщением, а не молча
 * сохранит NaN или старое значение).
 */
export function parseDecimal(raw) {
    const t = raw.trim();
    if (t === '')
        return undefined;
    const normalized = t.replace(',', '.');
    if (!/^-?\d*\.?\d+$|^-?\d+\.$/.test(normalized))
        return raw;
    return Number(normalized);
}
/** Число для поля ввода — с русской запятой. */
export function formatDecimalRu(value) {
    if (typeof value !== 'number' || !Number.isFinite(value)) {
        return value === undefined || value === null ? '' : String(value);
    }
    return String(value).replace('.', ',');
}
/**
 * Дробное число с запятой (`meta.widget: 'decimal'`). `NumberWidget` рисует
 * `type="number"`, а такое поле в русской локали браузера отвергает или
 * теряет «1,5» — оператор видит «×1,5» на экране и вводит так же.
 *
 * Как у `NumberWidget`, пока поле правят, авторитетен НАБРАННЫЙ ТЕКСТ
 * (`useDraftValue`): промежуточное «1,» не обязано быть числом.
 */
export function DecimalWidget(props) {
    const { field, fieldState, meta, label, description, hint, readonly, disabled } = props;
    const draft = useDraftValue(field, parseDecimal, formatDecimalRu);
    return (_jsx(FieldShell, { meta: meta, fieldState: fieldState, label: label, description: description, hint: hint, htmlFor: field.name, children: _jsx(Input, { id: field.name, name: field.name, type: "text", inputMode: "decimal", ref: field.ref, onBlur: field.onBlur, onChange: (e) => draft.onChange(e.target.value), value: draft.value, placeholder: meta.placeholder, readOnly: readonly ?? meta.readonly, disabled: disabled }) }));
}
//# sourceMappingURL=decimal.js.map